import ShiftDeclinedReason from "@/models/Shared/ShiftDeclinedReason";

export default class AnonOfferedReplyDto {
    bookingRoleWorkerShiftId = '';
	applied:   boolean;
	declinedReason: ShiftDeclinedReason = ShiftDeclinedReason.BOOKING_DECLINED_REASON_UNDEFINED;
}